import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import shortid from 'shortid';
import onClickOutside from 'react-onclickoutside';

// Helper functions
const seasonOptionName = (season) => {
  const startYear = parseInt(season.starts_on, 10)
  const endYear = parseInt(season.ends_on, 10)

  return startYear === endYear ? startYear : `${startYear} - ${endYear}`
}

const DropdownMenu = ({ options, handleOptionClick }) => {
  if (options.length <= 0) {
    return null
  } else {
    return (
      <div className="profile-dropdown-menu">
        {
          options.map((option) => (
            <div className="profile-dropdown-menu-option" key={shortid.generate()} onClick={() => handleOptionClick(option)} >
              {seasonOptionName(option)}
            </div>
          ))
        }
      </div>
    )
  }
}


class ProfileDropdown extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.object.isRequired,
    handleSelectionUpdate: PropTypes.func.isRequired
  }

  state = {
    menuIsVisible: false
  }

  unselectedOptions = () => {
    const { options, selectedOption } = this.props

    return options.filter((option) => option !== selectedOption)
  }

  handleOptionClick = (option) => {
    this.props.handleSelectionUpdate(option);
  }

  toggleDropdownMenu = () => {
    const { menuIsVisible } = this.state;

    this.setState({ menuIsVisible: !menuIsVisible})
  }

  handleClickOutside = () => {
    if (this.state.menuIsVisible) {
      this.toggleDropdownMenu();
    }
  }

  render() {
    let { selectedOption } = this.props;
    let { menuIsVisible } = this.state;

    return (
      <div
        className={`profile-dropdown${this.unselectedOptions().length === 0 ? ' single-option' : ''}`}
        onClick={this.toggleDropdownMenu}
      >
        <div className="profile-dropdown-selection">
          { seasonOptionName(selectedOption) }
        </div>
        {
          menuIsVisible &&
          <DropdownMenu
            options={this.unselectedOptions()}
            handleOptionClick={this.handleOptionClick}
          />
        }
      </div>
    );
  }
}

export default onClickOutside(ProfileDropdown);



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileDropdown.js